import React from "react";
import styled from "styled-components";

const Separator = styled.div`
  border: 1px solid #dbdbdb;
`;

const HorizontalSeparator = () => <Separator />;

export default HorizontalSeparator;
